import { memo } from 'react';

import CustomCodeIconSVG from '@/assets/custom-code-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICustomCodeIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={CustomCodeIconSVG} {...props} />
);

export const CustomCodeIcon = memo(ICustomCodeIcon) as typeof ICustomCodeIcon;
